import React, { useState, useEffect } from 'react'; 
//import { useEffect } from 'react';
import { makeStyles } from '@mui/styles';
import Button from '@mui/material/Button';
import {globalTheme} from './Theme'
import Icon from '@mui/material/Icon';

const useStyles = makeStyles((theme) => ({
    button: {
        background: 'rgba(155, 155, 155, 0.4)',
        padding: "13px",
        borderRadius: "40px",
        right: theme.spacing(10),
        bottom: theme.spacing(5),
        position: "fixed",
        zIndex: 99
    },
  }));

export default function ScrollToTopButton(props) {
    const classes = useStyles(globalTheme);

    const [scrollPosition, setScrollPosition] = useState(0);
    const handleScroll = () => {
        const position = window.scrollY;
        setScrollPosition(position);
    };

    const scrollToTop = () => {
      window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      //setScrollPosition(0);
    };
    
    useEffect(() => {
        window.addEventListener('scroll', handleScroll, { passive: true });
    
        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    return (
      scrollPosition > 0 ?
        <Button 
          className={classes.button} 
          size='large'
          color="secondary"
          onClick={scrollToTop}>
            <Icon className="fas fa-arrow-up" fontSize="large" style={{color:"rgb(218, 232, 248)"/*"#647993"*/}}></Icon>
        </Button>
        :
        null
    );
}